import { BLACK, PRIMARY_PURPLE } from '../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../theme/fontConstants';

// eslint-disable-next-line import/prefer-default-export
export const textFieldSx = {
  width: '100%',
  '& .MuiOutlinedInput-root': {
    backgroundColor: BLACK[0],
    borderRadius: '6px',
    color: BLACK[100],
    marginTop: 0,
  },
  '& .MuiInputBase-input': {
    fontFamily: PRIMARY_FONT[400],
    fontSize: '14px',
  },
  '& .MuiOutlinedInput-input:not(.MuiInputBase-inputMultiline)': {
    padding: '10px 12px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: `1px solid ${BLACK[40]}`,
  },
  '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: BLACK[50],
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: `1px solid ${PRIMARY_PURPLE[70]}`,
  },
};
